import { isErrorStatus, isLoadingStatus, useResource, useResourceRoute } from 'json-api-hooks';
import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router';

import CardContent from '../../../components/Card/CardContent';
import CardMain from '../../../components/Card/CardMain';
import Container from '../../../components/Container';
import ErrorPage from '../../../components/Error/ErrorPage';
import Heading from '../../../components/Heading';
import { LoadingPage } from '../../../components/Loading';
import VisitForm from '../../../forms/VisitForm';
import retrievePath from '../../../lib/iris';

const AddressShow: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [address, status] = useResource({ type: 'addresses', id: id! });
  const streetRoute = useResourceRoute(address?.relationships.street.data);
  const goToStreet = () => streetRoute && navigate(retrievePath(streetRoute));

  if (isLoadingStatus(status)) {
    return <LoadingPage />;
  }

  if (isErrorStatus(status) || !address) {
    return <ErrorPage status={status} />;
  }

  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Heading>{address.attributes.name}</Heading>
          <VisitForm address={address} onClose={goToStreet} />
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default AddressShow;
